import { FoodSet, UnavailableError, listCategory, types as rs } from 'earn-ts';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/app/store';
import Card from 'src/components/Order/Card';
import Footer from 'src/components/Order/FooterComponent';
import Header from 'src/components/Order/HeaderComponent';
import { addIdCategory, addListMenuSets } from 'src/reducer/order/orderReducer';
import { pickName } from 'src/utils';
import { storedMenuDef } from 'src/utils/orderStore';
import FoodImage from 'src/components/Order/FoodImage';
import { useInitSession } from 'src/hook/useInitSession';
import { useIsAvailable } from 'src/hook/useIsAvailable';
import Loader from 'src/components/Loader';

/* Screen which lists categories */
export default function Index() {
  const dispatch = useAppDispatch();
  const {
    categories,
    fullOrder,
    loadOrderStatus,
    menuDef,
    session,
    titleHeader,
  } = useAppSelector(state => state.order);
  const navigate = useNavigate();

  const { language } = useTranslation(['main']).i18n;
  const pathParams = useParams();
  const _ = useInitSession();

  const isAvailable = useIsAvailable();

  const filteredCategories = useMemo(
    () =>
      (categories ?? [])
        .map((it): [rs.MenuCat, UnavailableError] => [it, isAvailable(it)])
        .filter(([_, a]) => [null, 'sold_out'].includes(a)),
    [categories, session],
  );

  console.log(
    fullOrder?.table?.json?.menu_items,
    ' #',
    fullOrder?.table?.num_id,
    ' id: ',
    fullOrder?.table?.id,
  );

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getAllCats = async () => {
      setLoading(true);
      let menuSets: Record<string, FoodSet[]> = {};
      console.log('filteredCategories', menuDef);
      await Promise.all(
        filteredCategories.map(async ([item, stat]) => {
          return await Promise.all(
            (await listCategory(item, storedMenuDef)).map(async it => {
              it.saveCaption(language);
              let def = await it.menu();
              // filtering by availability happens in the ListMenuSet component
              if (!menuSets[item.id]) {
                menuSets[item.id] = [it];
              } else menuSets[item.id].push(it);
            }),
          );
        }),
      );
      dispatch(addListMenuSets(menuSets));
    };
    getAllCats().finally(() => {
      setLoading(false);
    });
  }, [filteredCategories, language]);

  const getIdCategory = (itemCate: string | null) => {
    dispatch(addIdCategory(itemCate));
    navigate(`/order/${pathParams.shopId}/listMenuSet`);
  };

  return (
    <div className="font-medium text-center flex flex-col items-center relative">
      <div className="top-0 z-20 left-0 fixed px-[15px] pt-[5px] w-full scroll-smooth font-medium shadow-md bg-white">
        <Header
          title={titleHeader}
          isShowBack={false}
          isShowMenu={true}
          isHideScroll={true}
        />
      </div>
      {loading ? (
        <div className="mt-[70px]">
          <Loader />
        </div>
      ) : (
        <div className="grid md:grid-cols-4 mobile-l:grid-cols-3 grid-cols-2 w-full h-full mt-[70px] gap-3 px-3">
          {filteredCategories!.map(
            ([item, stat]: [rs.MenuCat, UnavailableError], index: number) => (
              <Card onClick={() => getIdCategory(item.id)} key={index}>
                <div className="h-full w-full flex flex-col aspect-square">
                  {stat === 'sold_out' ? (
                    'SOLD OUT'
                  ) : (
                    <FoodImage
                      food={{ kind: 'category', id: item.id }}
                      className="w-full aspect-square rounded-t-md object-cover"
                    />
                  )}
                  <div className="grow flex p-2 items-center justify-center">
                    <p className="text-base text-center leading-4">
                      {pickName(item, language)}
                    </p>
                  </div>
                </div>
              </Card>
            ),
          )}
        </div>
      )}
      <Footer />
    </div>
  );
}
